import { Mappable } from "../../../_shared/mappable.class";
import { Event } from '../Event'

export class PledgePerWinTeam extends Mappable<PledgePerWinTeam> {
    teamId: number;
    name: string;
    description: string;
    logoUrl: string;
    sport: string;
}